<template lang="html">
  <tr>
    <td class="column-id link" @click.self="go_to_user">
      {{ !is_japan_locale ? model.first_name : model.last_name }}
    </td>

    <td class="column-id link" @click.self="go_to_user">
      {{ !is_japan_locale ? model.last_name : model.first_name }}
    </td>

    <td class="column-id link" @click.self="go_to_user">
      <a v-if="model.email" :href="'mailto:' + model.email">{{model.email}}</a>
    </td>

    <td class="column-id link" @click.self="go_to_user">
      {{ model.phone }}
    </td>

    <td class="column-id link" @click.self="go_to_user">
      <div>{{is_main ? $tr('common.yes') : $tr('common.no')}}</div>
      <div v-if="!is_main"><button class="vcv-button link transparent" @click="set_main">{{ $tr('admin_console.company.settings.managers.makeMainManager') }}</button></div>
    </td>

    <td class="column-id link" @click.self="go_to_user">
      <button class="vcv-button gray iconed response-link button-cell button-cell--remove" @click="remove" :title="$tr('common.delete')">
        <i class="icon icon-garbage"/> 
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'recruiter-row',

    components: {},

    props: {
      model: Object,
      is_japan_locale: Boolean
    },

    methods: {
      go_to_user() {
        let routeData = this.$router.resolve({path: this.recruiter_route});
        window.open(routeData.href, '_blank');
      },

      remove() {
        this.$emit('remove', this.model.id);
      },

      set_main() {
        this.$emit('set_main', this.model);
      }
    },

    computed: {
      recruiter_route() {
        return `/admin/settings/users/${this.model.user_id}`;
      },

      is_main() {
        if (!this.model) {
          return false;
        }

        return this.model.is_main
      }
    }
  }
</script>

<style lang="scss" scoped>

    .column-vacancies * {
        font-size: 12px;
    }

    .vcv-button {
        padding: 10px 15px;
    }

    .vacancies-list {
        position: absolute;
        z-index: 9999;
        border: 1px solid grey;
        background: white;
        padding: 2px;

    }

    .vacancies-list * {
        transition-duration: 0s;
        transition-delay: 0s;
    }

    .vcv-button {
      &.link {
        padding: 0;
      }
    }

</style>
